import React from 'react';
import { CommandBar } from '@fluentui/react/lib/CommandBar';
import { useTranslation } from 'react-i18next';
import { messageService } from '../../../services/messageService';
import { useDispatch, useSelector } from 'react-redux';
import { saveHRStateAttr } from '../../../reducers/humanResourceReducer';
import WorkerRemoveModal from '../documentPane/workerRemoveModel/workerRemoveModel';

const CommandBarRight = () => {
  const { t } = useTranslation();
  const newClick = () => {
    messageService.sendMessage({ isNewHR: true });
    // props.createNew(true);
  };
  const saveFormData = () => {
    messageService.sendMessage({ saveHRData: true });
  };

  const dispatch = useDispatch();
  useSelector((state: any) => state.hr?.formData?.id);
  const getItems = () => {
    return [
      {
        key: 'new',
        text: t('new'),
        iconProps: { iconName: 'Add' },
        onClick: () => {
          newClick();
        },
        disabled: false,
      },
      {
        key: 'save',
        text: t('save'),
        iconProps: { iconName: 'Save' },
        onClick: () => {
          saveFormData();
        },
        disabled: false,
      },
      {
        key: 'Remove',
        onClick: () => {
          dispatch(saveHRStateAttr('isHumanDeleteModelOpen', true));
        },
        name: t('remove'),
        iconProps: { iconName: 'Delete' },
        disabled: false,
      },
    ];
  };

  return (
    <div>
      <CommandBar
        items={getItems()}
        ariaLabel="Use left and right arrow keys to navigate between commands"
      />
      <WorkerRemoveModal/>
    </div>
  );
};

export default CommandBarRight;
